import { RawMaterialMasterThemeSizeConfig } from './types';

const small: RawMaterialMasterThemeSizeConfig = {
  rawMaterialMaster: {},
};

export default small;
